import * as R from "ramda";
import { FREQUENCY_ATTRIBUTE_IDS } from "./constants/frequency.mjs";
const isFrequencyAttribute = (attribute) => R.includes(R.prop("id", attribute), FREQUENCY_ATTRIBUTE_IDS);
export {
  isFrequencyAttribute
};
